import React from "react";

type IconProps = {
  size?: number;
  color?: string;
};

/** Figma return arrow — Back to facility network */
export function FacilityNetworkReturnIcon({
  size = 15,
  color = "#262626",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      aria-hidden
    >
      <path
        d="M3.35355 0.146447C3.54882 0.341709 3.54882 0.658291 3.35355 0.853553L1.70711 2.5H8.5C11.8137 2.5 14.5 5.18629 14.5 8.5C14.5 11.8137 11.8137 14.5 8.5 14.5C5.18629 14.5 2.5 11.8137 2.5 8.5C2.5 8.22386 2.72386 8 3 8C3.27614 8 3.5 8.22386 3.5 8.5C3.5 11.2614 5.73858 13.5 8.5 13.5C11.2614 13.5 13.5 11.2614 13.5 8.5C13.5 5.73858 11.2614 3.5 8.5 3.5H1.70711L3.35355 5.14645C3.54882 5.34171 3.54882 5.65829 3.35355 5.85355C3.15829 6.04882 2.84171 6.04882 2.64645 5.85355L0.146447 3.35355C-0.0488155 3.15829 -0.0488155 2.84171 0.146447 2.64645L2.64645 0.146447C2.84171 -0.0488155 3.15829 -0.0488155 3.35355 0.146447Z"
        fill={color}
      />
    </svg>
  );
}

/** Figma Person Star — Enter NPI section header */
export function EnterCcnSectionIcon({
  size = 24,
  color = "#065b70",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M4.7998 14.3992C4.7998 16.5624 6.66542 18.7828 9.86591 19.1472C9.52382 18.7244 9.23292 18.2584 9.00262 17.7587C7.05804 17.1989 5.9998 15.753 5.9998 14.3992V13.7992C5.9998 13.4678 6.26843 13.1992 6.5998 13.1992H8.64824C8.76657 12.7809 8.92512 12.3794 9.11946 11.9992H6.5998C5.60569 11.9992 4.7998 12.8051 4.7998 13.7992V14.3992ZM14.0998 7.49922C14.0998 7.84152 14.0477 8.17165 13.951 8.4821C13.368 8.57519 12.8105 8.74461 12.2891 8.97981C12.6665 8.60013 12.8998 8.07692 12.8998 7.49922C12.8998 6.33942 11.9596 5.39922 10.7998 5.39922C9.64001 5.39922 8.6998 6.33942 8.6998 7.49922C8.6998 8.65902 9.64001 9.59922 10.7998 9.59922C10.967 9.59922 11.1297 9.57968 11.2856 9.54275C10.8052 9.87041 10.3702 10.2599 9.99225 10.6997C8.56009 10.3395 7.4998 9.04316 7.4998 7.49922C7.4998 5.67668 8.97727 4.19922 10.7998 4.19922C12.6223 4.19922 14.0998 5.67668 14.0998 7.49922ZM20.3998 14.9992C20.3998 17.9816 17.9821 20.3992 14.9998 20.3992C12.0175 20.3992 9.5998 17.9816 9.5998 14.9992C9.5998 12.0169 12.0175 9.59922 14.9998 9.59922C17.9821 9.59922 20.3998 12.0169 20.3998 14.9992ZM15.571 11.8319C15.3912 11.255 14.6084 11.255 14.4286 11.8319L13.8556 13.67H12.0016C11.4197 13.67 11.1778 14.4461 11.6485 14.8026L13.1485 15.9387L12.5756 17.7768C12.3958 18.3536 13.0291 18.8333 13.4998 18.4768L14.9998 17.3408L16.4998 18.4768C16.9705 18.8333 17.6038 18.3536 17.424 17.7768L16.8511 15.9387L18.3511 14.8026C18.8218 14.4461 18.5799 13.67 17.998 13.67H16.144L15.571 11.8319Z"
        fill={color}
      />
    </svg>
  );
}

export function InfoCircleIcon({ size = 16, color = "#c48029" }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5ZM8 6.75C8.41421 6.75 8.75 7.08579 8.75 7.5V11C8.75 11.4142 8.41421 11.75 8 11.75C7.58579 11.75 7.25 11.4142 7.25 11V7.5C7.25 7.08579 7.58579 6.75 8 6.75ZM8 4.75C8.55228 4.75 9 5.19772 9 5.75C9 6.30228 8.55228 6.75 8 6.75C7.44772 6.75 7 6.30228 7 5.75C7 5.19772 7.44772 4.75 8 4.75Z"
        fill={color}
      />
    </svg>
  );
}

/** Fluent Send — Figma node 8006:64224 */
export function SendLinkIcon({ size = 16, color = "#e6fafc" }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        d="M0.18412 0.11244C0.336572 -0.0118225 0.547712 -0.0351664 0.723627 0.0527913L15.7236 7.55279C15.893 7.63749 16 7.81062 16 8C16 8.18939 15.893 8.36252 15.7236 8.44722L0.723627 15.9472C0.547712 16.0352 0.336572 16.0118 0.18412 15.8876C0.0316676 15.7633 -0.0337739 15.5612 0.0169031 15.3712L1.98255 8L0.0169031 0.628836C-0.0337739 0.438798 0.0316676 0.236702 0.18412 0.11244ZM2.88416 8.5L1.26911 14.5564L14.382 8L1.26911 1.44357L2.88416 7.5H9.50002C9.77616 7.5 10 7.72386 10 8C10 8.27615 9.77616 8.5 9.50002 8.5H2.88416Z"
        fill={color}
      />
    </svg>
  );
}

/** Fluent Search Shield — parent link request banner (Figma 8609) */
export function SearchShieldIcon({ size = 20, color = "#ed6c02" }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M9.5 2.75C6.6005 2.75 4.25 5.1005 4.25 8C4.25 11.5899 9.5 17.25 9.5 17.25C9.5 17.25 14.75 11.5899 14.75 8C14.75 5.1005 12.3995 2.75 9.5 2.75ZM9.5 10.25C8.25736 10.25 7.25 9.24264 7.25 8C7.25 6.75736 8.25736 5.75 9.5 5.75C10.7426 5.75 11.75 6.75736 11.75 8C11.75 9.24264 10.7426 10.25 9.5 10.25Z"
        fill={color}
      />
      <path
        d="M15.5 3.5L17 5L14.5 7.5L13 6L15.5 3.5Z"
        fill={color}
      />
    </svg>
  );
}

/** Fluent People Link — parent link request dialog */
export function PeopleLinkIcon({ size = 16, color = "#05495a" }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M5.5 7.5C6.88071 7.5 8 6.38071 8 5C8 3.61929 6.88071 2.5 5.5 2.5C4.11929 2.5 3 3.61929 3 5C3 6.38071 4.11929 7.5 5.5 7.5ZM10.5 7.5C11.3284 7.5 12 6.82843 12 6C12 5.17157 11.3284 4.5 10.5 4.5C9.67157 4.5 9 5.17157 9 6C9 6.82843 9.67157 7.5 10.5 7.5ZM2.5 12.25C2.5 10.7312 3.73122 9.5 5.25 9.5H5.75C6.16421 9.5 6.5 9.83579 6.5 10.25C6.5 10.6642 6.16421 11 5.75 11H5.25C4.55964 11 4 11.5596 4 12.25V12.5H7V12.25C7 11.5596 6.44036 11 5.75 11H5.25C4.83579 11 4.5 10.6642 4.5 10.25C4.5 9.83579 4.83579 9.5 5.25 9.5H5.75C7.26878 9.5 8.5 10.7312 8.5 12.25V13.25C8.5 13.6642 8.16421 14 7.75 14H2.25C1.83579 14 1.5 13.6642 1.5 13.25V12.25ZM10.75 9.5C12.2688 9.5 13.5 10.7312 13.5 12.25V13.25C13.5 13.6642 13.1642 14 12.75 14H10.25C9.83579 14 9.5 13.6642 9.5 13.25V12.25C9.5 10.7312 10.7312 9.5 12.25 9.5H12.75C13.1642 9.5 13.5 9.83579 13.5 10.25C13.5 10.6642 13.1642 11 12.75 11H12.25C11.5596 11 11 11.5596 11 12.25V12.5H13.5V12.25C13.5 11.5596 12.9404 11 12.25 11H11.75C11.3358 11 11 10.6642 11 10.25C11 9.83579 11.3358 9.5 11.75 9.5H12.25C13.7688 9.5 15 10.7312 15 12.25V13.25C15 13.6642 14.6642 14 14.25 14H9.75C9.33579 14 9 13.6642 9 13.25V12.25C9 10.7312 10.2312 9.5 11.75 9.5H12.25C12.6642 9.5 13 9.83579 13 10.25C13 10.6642 12.6642 11 12.25 11H11.75C11.0596 11 10.5 11.5596 10.5 12.25V12.5H13V12.25C13 11.5596 12.4404 11 11.75 11H10.5C9.67157 11 9 10.3284 9 9.5C9 8.67157 9.67157 8 10.5 8C11.3284 8 12 8.67157 12 9.5C12 10.3284 11.3284 11 10.5 11Z"
        fill={color}
      />
    </svg>
  );
}
